export const AUTH_CHILD_REQUIRED_FIELDS = ['_id', 'id', 'jwt', 'role', 'is_confirmed'];
